module.exports = __webpack_public_path__ + "img/marshall-islands.73148814.svg";